export default "__VITE_ASSET__vZkmVsd7__"